import { type IconProps, type TextProps } from '@loadsmart/miranda-react'

import { formatCurrency } from 'core/utils/currency'
import { formatToLocaleDate } from 'core/utils/date'

import { DocumentStatus, DocumentType } from '../domain/Document'

export function formatDocumentDate(date: string | null | undefined) {
  if (date) {
    return formatToLocaleDate(new Date(date), 'MMM d, yyyy, h:mm a')
  }
  return ''
}

export function formatDocumentValue(value: string | number | undefined, type: DocumentType) {
  if (value && (type === DocumentType.Invoice || type === DocumentType.RateConfirmation)) {
    return formatCurrency(Number(value), true)
  }

  if (value) {
    return value
  }

  if (type === DocumentType.BOL) {
    return 'No number'
  }

  return '-'
}

const iconDocumentStatusMap = {
  [DocumentStatus.Approved]: 'check',
  [DocumentStatus.PendingReview]: 'clock',
  [DocumentStatus.Denied]: 'x',
  [DocumentStatus.Disputing]: 'alert-circle',
  [DocumentStatus.Legacy]: 'file',
}

const iconDocumentStatusColorMap = {
  [DocumentStatus.Approved]: 'color-success-60',
  [DocumentStatus.PendingReview]: 'color-neutral-40',
  [DocumentStatus.Denied]: 'color-neutral-60',
  [DocumentStatus.Disputing]: 'color-danger-60',
  [DocumentStatus.Legacy]: 'color-neutral-100',
}

export function getDocumentIcon(status?: DocumentStatus | null): {
  name: IconProps['name']
  color: IconProps['color']
} {
  const defaultName = 'file'
  const defaultColor = 'color-neutral-100'
  if (!status) {
    return {
      name: defaultName,
      color: defaultColor,
    }
  }

  return {
    name: (iconDocumentStatusMap[status] as IconProps['name']) ?? defaultName,
    color: (iconDocumentStatusColorMap[status] as IconProps['color']) ?? defaultColor,
  }
}

const documentStatusLabel = {
  [DocumentStatus.Approved]: 'Approved',
  [DocumentStatus.PendingReview]: 'Pending Review',
  [DocumentStatus.Denied]: 'Denied',
  [DocumentStatus.Disputing]: 'Disputing',
  [DocumentStatus.Legacy]: '',
}

export function getDocumentStatusLabel(status?: DocumentStatus | null) {
  if (!status) {
    return ''
  }
  return documentStatusLabel[status]
}

export function getDocumentTitleProps(status?: DocumentStatus | null): Partial<{
  color: TextProps['color']
}> {
  if (status === DocumentStatus.Denied) {
    return { color: 'color-text-placeholder' }
  }

  return {}
}
